import { Component, OnInit, Input } from '@angular/core';
import { MessengerService, MessageSubject } from 'src/app/core/service/messenger.service';
import { CaseService } from 'src/app/core/service/case.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { sortBy } from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { CaseUtility } from '../case.utility';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';

@Component({
  selector: 'app-case-change-priority',
  templateUrl: './case-change-priority.component.html',
  styleUrls: ['./case-change-priority.component.scss']
})
export class CaseChangePriorityComponent implements OnInit
{
  /**
   * The case to assign.
   */
  @Input() public aCase;

  /**
   * Case priority form.
   */
  public caseChangePriorityForm: UntypedFormGroup;

  /**
   * Get the list of priority options for Cases.
   */
  public priorities = [];

  /**
   * Filtered priorities
   */
  public prioritiesFiltered = [];

  /**
   * Constructor
   */
  constructor(
    private messengerService: MessengerService,
    private messageHandlerService: MessageHandlerService,
    private translate: TranslateService,
    private caseService: CaseService,
    private caseUtilityService: CaseUtility)
  { }

  public ngOnInit(): void
  {
    this.priorities = this.caseUtilityService.distinctPriorities;

    // Initialize the form group for case priority
    this.caseChangePriorityForm = new UntypedFormGroup(
      {
        selectedPriority: new UntypedFormControl(null, Validators.required),
        reasonForPriorityChanges: new UntypedFormControl(null, Validators.required)
      });

    // Attempt to get case for consent security reason only
    this.caseService.getCaseDetails(this.aCase.id, 'OPEN').subscribe({
      next: () =>
      {
        this.casePriorityFilter(this.aCase.priority);
      }
    });
  }

  /**
   * Filter handler for case priority dropdown.
   *
   * @param value User input.
   */
  public casePriorityFilter(value): any
  {
    this.prioritiesFiltered = sortBy(this.priorities.filter(p =>
      (!p.priority.includes(value || this.aCase.priority)) &&
      !p.priority.includes(this.aCase.priority)), ['priorityName']);
  }

  /**
   * Save the new case manager.
   */
  public save(): void
  {
    const selectedPriority = this.caseChangePriorityForm.get('selectedPriority').value;
    const reason = this.caseChangePriorityForm.get('reasonForPriorityChanges').value;

    // call case service to save the case.
    const casePriority: any = {};
    casePriority.priority = selectedPriority.priority;
    casePriority.priorityText = selectedPriority.priorityName;
    casePriority.reason = reason;

    this.caseService.updateCasePriority(this.aCase.id, casePriority).subscribe({
      next: () =>
      {
        // send a message to other components.
        this.messengerService.sendMessage(new MessageSubject('casePriorityUpdated', {
          id: selectedPriority.priority,
          priority: selectedPriority.priorityName
        }));
        this.messageHandlerService.displaySuccess('PRIORITY-CHANGED-SUCCESSFULLY');
      },
      error: (errorResponse) =>
      {
        this.messageHandlerService.displayError(errorResponse);
      }
    });
  }
}
